import { CoreApi } from '@inter-ikea-storageone/range';
import { Dispatch } from '@reduxjs/toolkit';

export enum RenderLocation {
  Root = 'Root',
  Header = 'Header',
  Action = 'Action'
}

/**
 * A feature that implements this interface must implement
 * the onViewerCreated function. The function runs in Scene.tsx
 * after the viewer has beem created.
 */
export interface UsesViewer {
  onViewerCreated(coreApi: CoreApi): void;
}

/**
 * A feature that implements this interface will render the
 * component returned by the component() function in Main.tsx
 */
export interface RendersComponent {
  /**
   * @returns a component that will be rendered in Main.tsx
   */
  render(location: RenderLocation): ((props?: any) => JSX.Element) | undefined;
}

/*
 * A feature that implements this interface implements a reset
 * function to be called when the planner resets
 */
export interface ShouldReset {
  reset(dispatch: Dispatch): void;
}

export abstract class Feature {
  public add(coreApi: CoreApi) {
    this.init(coreApi);
    return this;
  }

  protected abstract init(coreApi: CoreApi): void;
}
